import { render, staticRenderFns } from "./ColorFade.vue?vue&type=template&id=37d697a6"
import script from "./ColorFade.vue?vue&type=script&lang=js"
export * from "./ColorFade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports